import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  NgZone,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidationErrors,
} from "@angular/forms";
import { Attendance } from "../../../class/attendance";
import { CitationService } from "../../../service/citation/citation.service";
import { TranslateService } from "@ngx-translate/core";
import {
  Message,
  SelectItem,
} from "primeng/primeng";
import { RequisitionService } from "../../../service/requisition/requisition.service";
import { NotificationsService } from "../../../../../theme/services/notifications/notifications.service";
import { config } from "../../../../../../environments/config";
import { UploadFilesService } from "../../../service/upload-files/upload-files.service";
import { HasPermissionService } from "../../../service/has-permission/has-permission.service";
import { CandidateService } from "../../../service/candidate/candidate.service";
import { Candidate } from "../../../class/candidate";
import { formatDate } from "../../../../../theme/functions/formatDate.function";
import { calendarES } from "../../../../../theme/functions/calendarES";
import { Requisition } from "../../../class/requisition";
import { CandidateCommentService } from "../../../service/candidate-comment/candidate-comment.service";
import { CandidateEducationLevelOptions } from "../../../../../shared/constans";
import { enableChangeResult } from "../../../../../theme/functions/enableChangeResult.function";

@Component({
  selector: "app-new-citation",
  templateUrl: "./new-citation.component.html",
  styleUrls: ["./new-citation.component.scss"],
})
export class NewCitationComponent implements OnInit, OnChanges {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() edit: Attendance;
  @Input() idRequisition: string;
  @Input() idCitation: string;
  @Input() editPart: string;
  @Input() editEventPart: string;
  @Input() minimum: boolean;
  @Input() allinone: boolean;

  messages: Message[] = [];

  public uploadedFileTest: any[] = [];
  public prewiewFileTest: any;
  public promiseFileTest: Promise<any>;

  public apiUrl = config.API_ROOT;
  public msgs: Message[];

  public promiseForm: Promise<any>;
  public form: FormGroup;

  public customer_guide_id: number;

  public employeePositionToLoadSelection: string;
  public employeePositionToLoadDocumental: string;
  public employeePositionToLoadHire: string;
  public employeePositionToAdmin: string;
  public es: any;

  public resultOptions: SelectItem[];
  public resultOptionsDocumental: SelectItem[];
  public resultOptionsHire: any[] = [];
  public resultOptionsSelection: SelectItem[];
  public resultOptionsMedical: SelectItem[];
  public resultOptionsReferencing: SelectItem[];
  // public statusOptions: SelectItem[];
  public optionsSelectionStateBackups: SelectItem[];
  public optionsSelectionObservationBackups: SelectItem[];
  public managementOptions: SelectItem[];

  public salaryModalityOptions: SelectItem[];
  public paymentTypeOptions: SelectItem[];
    public modalityOptions: SelectItem[];
  public workingDayOptions: SelectItem[];
  public commissionsOptions: SelectItem[];

  public sourceOptions: SelectItem[];

  public requisition: Requisition;
  public modViewDialog: boolean;
  public modConfirmationDialog: boolean;
  public confirmation: boolean;
  public exclusion: boolean | undefined;
  public login_employee_id: number;
  public myEmployeeId: string;
  public myEmployee: any;
  public new_candidate_id: any;
  public modViewSpeechTextDialog: boolean;
  public candidate: Candidate;

  public show_temporary_hiring_reason: string = "";
  public show_hiring_reason_description: string = "";

  public show_venue: string = "";
  public show_company: string = "";
  public show_profile_survey_small: any;
  public show_profile_survey: string = "";
  public show_candidate: string = "";
  public show_candidate_info: any;
  public show_observation: string = "";
  public showPage: boolean = false;

  public rolesPermissionChangeHire: string = "";
  public withdrawalOptions: any[];
  public withdrawalReasonOptions: any[];

  public modViewNotifyCustomer: boolean;
  public notifyCustomerform: FormGroup;

  public currentRoleId: number;
  public employeeCityIdDisable: boolean = false;
  public exclusionBackgroundValidation: boolean = false;
  public exclusionReferencing: boolean = false;
  public exclusionDocumentalAnalysis: boolean = false;
  public exclusionMedicalExams: boolean = false;
  public showDateValidationDialog: boolean = false;
  public confirmationDialogMessage: string = "";
  public confirmationDialogMode:
    | "candidate_creation"
    | "send_documental_management" = "candidate_creation";
  public pendingSendDocumentalPayload: any = null;

  public nameExclusionBackgroundValidation: string =
    "exclusion_background_validation";
  public nameExclusionReferencing: string = "exclusion_referencing";
  public nameExclusionDocumentalAnalysis: string =
    "exclusion_documental_analysis";
  public nameExclusionMedicalExams: string = "exclusion_medical_exams";

  constructor(
    private fb: FormBuilder,
    public citationService: CitationService,
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    private ngZone: NgZone,
    private notificationsService: NotificationsService,
    public uploadFilesService: UploadFilesService,
    public requisitionService: RequisitionService,
    public candidateService: CandidateService,
    public candidateCommentService: CandidateCommentService
  ) {
    this.modViewDialog = false;
    this.modConfirmationDialog = false;
    this.confirmation = false;
    this.exclusion = undefined;

    this.modViewSpeechTextDialog = false;

    this.modViewNotifyCustomer = false;

    this.login_employee_id = JSON.parse(
      localStorage.getItem("profile")
    ).employee_id;

    this.employeePositionToLoadSelection = "4,5,6,7,8,9,10,21,24,25,38,53";
    this.employeePositionToLoadDocumental = "4,5,6,7,8,9,10,24,25,38,53";
    this.employeePositionToLoadHire = "5,6,7,8,9,10,24,25,38,53";

    this.rolesPermissionChangeHire =
      "1,2,16,20,21,29,30,34,35,36,37,38,39,40,41,42,43,77";
    var employeePosition = this.getRoleId();

    this.resultOptions = [
      // {label: 'Pendiente', value: 'Pendiente'},
      // {label: 'En Proceso', value: 'En Proceso'},
      { label: "Favorable", value: "Favorable" },
      { label: "No Apto", value: "No Apto" },
      { label: "Novedad", value: "Novedad" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "No asistió", value: "No asistió" },
    ];

    this.resultOptionsReferencing = [
      { label: "Favorable", value: "Favorable" },
      { label: "No Apto", value: "No Apto" },
      { label: "Novedad", value: "Novedad" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "Reingreso", value: "Reingreso" },
      { label: "Sin Documentos", value: "Sin Documentos" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.resultOptionsMedical = [
      // {label: 'Pendiente', value: 'Pendiente'},
      // {label: 'En Proceso', value: 'En Proceso'},
      { label: "Favorable", value: "Favorable" },
      { label: "No Apto", value: "No Apto" },
      { label: "Compromiso", value: "Compromiso" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "Aplazado", value: "Aplazado" },
      { label: "No asistió", value: "No asistió" },
      { label: "Examen cargado", value: "Examen cargado" },
      { label: "Candidato en atención", value: "Candidato en atención" },
      {
        label: "No ha llegado el examen médico al correo",
        value: "No ha llegado el examen médico al correo",
      },
      {
        label: "Se esta ampliando información",
        value: "Se esta ampliando información",
      },
      {
        label: "Pendiente cierre de historia clinica",
        value: "Pendiente cierre de historia clinica",
      },
    ];

    this.resultOptionsSelection = [
      { label: "Favorable", value: "Favorable" },
      { label: "No Apto", value: "No Apto" },
      { label: "Novedad", value: "Novedad" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "No Contestó", value: "No Contestó" },
      { label: "No asistió", value: "No asistió" },
    ];

    this.resultOptionsDocumental = [
      { label: "Favorable", value: "Favorable" },
      { label: "No Apto", value: "No Apto" },
      { label: "Novedad", value: "Novedad" },
      { label: "Autorizado", value: "Autorizado" },
      { label: "Revisado", value: "Revisado" },
      { label: "Sin Documentos", value: "Sin Documentos" },
      { label: "No aplica", value: "No aplica" },
    ];

    this.resultOptionsHire = [
      {
        label: "Contratado",
        value: "Contratado",
        disabled: this.enableOptionsHire(employeePosition),
      },
      { label: "Candidato desistió", value: "Candidato desistió" },
      { label: "Cancelado por el cliente", value: "Cancelado por el cliente" },
      {
        label: "Inexistencia",
        value: "Inexistencia",
        disabled: this.enableOptionsHire(employeePosition),
      },
      {
        label: "Inejecución",
        value: "Inejecución",
        disabled: this.enableOptionsHire(employeePosition),
      },
      { label: "No apto en ESC", value: "No apto en ESC" },
      { label: "No contratado", value: "No contratado", disabled: true },
    ];

    this.sourceOptions = [
      { label: "Volanteo", value: "Volanteo" },
      { label: "Portal de candidatos", value: "Portal de candidatos" }, // Hojas de Vida Redes Humanas
      {
        label: "Bolsa de Trabajo de la Universidad",
        value: "Bolsa de Trabajo de la Universidad",
      },
      { label: "Mercado Natural", value: "Mercado Natural" },
      { label: "Computrabajo", value: "Computrabajo" },
      { label: "El Empleo", value: "El Empleo" },
      { label: "Cliente", value: "Cliente" },
      { label: "Familiares o Amigos", value: "Familiares o Amigos" },
      { label: "Ferias", value: "Ferias" },
      { label: "Periódico o Revistas", value: "Periódico o Revistas" },
      { label: "Reclutador externo", value: "Reclutador externo" },
      { label: "Redes Sociales", value: "Redes Sociales" },
      { label: "SENA", value: "SENA" },
      { label: "Alentti", value: "Alentti" },
      { label: "Vincuventas", value: "Vincuventas" },
      { label: "LinkedIn ", value: "LinkedIn " },
      { label: "Cajas de compensación", value: "Cajas de compensación" },
      { label: "Indeed", value: "Indeed" },
      { label: "Hoy Trabajas", value: "Hoy Trabajas" },
      { label: "Trabajos Diarios", value: "Trabajos Diarios" },
      { label: "Talentu", value: "Talentu" },
      { label: "Chatbox", value: "Chatbox" },
      { label: "empleosdeleje.com", value: "empleosdeleje.com" },
      {
        label: "Aplicación desde portal candidatos",
        value: "Aplicación desde portal candidatos",
      },
      { label: "Otro", value: "Otro" },
    ];

    this.managementOptions = [
      { label: "Citado", value: "Citado" },
      { label: "Citado Para Contratación", value: "Citado Para Contratación" },
      {
        label: "Citado Para Empresa Usuaria",
        value: "Citado Para Empresa Usuaria",
      },
      {
        label: "Citado Para Examen Médico",
        value: "Citado Para Examen Médico",
      },
      { label: "Pendiente Por Citar", value: "Pendiente Por Citar" },
      { label: "Reclutamiento Nocturno", value: "Reclutamiento Nocturno" },
      { label: "No Contesta", value: "No Contesta" },
      {
        label: "No Le Interesa Por Distancia",
        value: "No Le Interesa Por Distancia",
      },
      {
        label: "No Le Interesa Por Horarios",
        value: "No Le Interesa Por Horarios",
      },
      {
        label: "No Le Interesa Por Salario",
        value: "No Le Interesa Por Salario",
      },
      {
        label: "No le interesa por condiciones laborales",
        value: "No le interesa por condiciones laborales",
      },
      { label: "Numero Apagado", value: "Numero Apagado" },
      { label: "Numero Equivocado", value: "Numero Equivocado" },
      { label: "Numero Fuera de Servicio", value: "Numero Fuera de Servicio" },
      {
        label: "Se Deja Mensaje Con Familiar/Amigo",
        value: "Se Deja Mensaje Con Familiar/Amigo",
      },
      { label: "Se Deja Mensaje De Voz", value: "Se Deja Mensaje De Voz" },
      { label: "Se Deja Razon", value: "Se Deja Razon" },
      { label: "Se Encuentra En Proceso", value: "Se Encuentra En Proceso" },
      { label: "Se Encuentra Estudiando", value: "Se Encuentra Estudiando" },
      { label: "Se Encuentra Laborando", value: "Se Encuentra Laborando" },
      { label: "Se Encuentra Viajando", value: "Se Encuentra Viajando" },
      {
        label: "Ya Realizo Proceso Con La Misma EU",
        value: "Ya Realizo Proceso Con La Misma EU",
      },
      { label: "No Cumple Con El Perfil", value: "No Cumple Con El Perfil" },
      { label: "Otro", value: "Otro" },
    ];

    this.optionsSelectionStateBackups = [
      {
        label: "Seleccionado listo para contratar",
        value: "Seleccionado listo para contratar",
      },
      {
        label: "Pendiente entrevista coordinador",
        value: "Pendiente entrevista coordinador",
      },
      { label: "No continua", value: "No continua" },
      {
        label: "Enviado analista Claro sin retroalimentación",
        value: "Enviado analista Claro sin retroalimentación",
      },
      { label: "Contratado", value: "Contratado" },
    ];

    this.optionsSelectionObservationBackups = [
      { label: "No cumple con el perfil", value: "No cumple con el perfil" },
      {
        label: "No seleccionado por el coordinador",
        value: "No seleccionado por el coordinador",
      },
      { label: "Ya no esta disponible", value: "Ya no esta disponible" },
    ];

    this.salaryModalityOptions = [
      { label: "Ordinario", value: "Ordinario" },
      { label: "Integral", value: "Integral" },
    ];

    this.paymentTypeOptions = [
      { label: "Fijo Mensual", value: "Fijo Mensual" },
      { label: "Por Hora", value: "Por Hora" },
      { label: "Quincenal", value: "Quincenal" },
      { label: "Destajo", value: "Destajo" },
    ];

    this.modalityOptions = [
      { label: "Presencial", value: "Presencial" },
      { label: "Teletrabajo", value: "Teletrabajo" },
      { label: "Mixto", value: "Mixto" },
    ];

    this.workingDayOptions = [
      { label: "Tiempo Completo", value: "Tiempo Completo" },
      { label: "Medio Tiempo", value: "Medio Tiempo" },
      { label: "Especial", value: "Especial" },
    ];

    this.commissionsOptions = [
      { label: "Sí", value: "1" },
      { label: "No", value: "0" },
    ];

    this.withdrawalOptions = [
      { id: 1, label: "No", value: "No" },
      { id: 2, label: "Sí", value: "Sí" },
    ];

    this.withdrawalReasonOptions = [
      { id: 1, label: "Salario", value: "Salario" },
      { id: 2, label: "Horario", value: "Horario" },
      { id: 3, label: "Ubicación", value: "Ubicación" },
      { id: 4, label: "No le interesa", value: "No le interesa" },
      { id: 5, label: "Otro", value: "Otro" },
    ];

    this.myEmployeeId = JSON.parse(localStorage.getItem("profile")).employee_id;
    this.myEmployee = JSON.parse(localStorage.getItem("profile")).employee;

    this.es = calendarES();

    this.form = fb.group({
      read: [null],
      candidate_id: [
        null,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],
      requisition_observation: [{ value: "", disabled: true }],
      management: [
        null,
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],

      date_citations: [null],
      source: [
        "",
        Validators.compose([Validators.required, Validators.minLength(1)]),
      ],

      withdrawal: [
        this.withdrawalOptions[0],
        Validators.compose([Validators.minLength(1)]),
      ],
      withdrawal_reason: ["", Validators.compose([Validators.minLength(2)])],
      withdrawal_observations: [
        "",
        Validators.compose([Validators.minLength(2)]),
      ],

      recruited: ["0"],
      recruited_at: [null],
      recruited_by_id: [this.myEmployeeId],
      recruited_accepted: ["1"],
      recruited_accepted_at: [null],
      // 'elaborated_by_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
      called_by_id: [this.myEmployeeId],
      // 'time': [''],
      observation_citation: [""],
      attended: [null],
      // 'arrival_time': [''],
      //interview en componente hijo

      send_customer_by_id: [null],
      observation_send_customer: [""],
      result_send_customer: [""],
      start_send_customer: [{ value: null, disabled: true }],
      end_send_customer: [{ value: null, disabled: true }],

      tested_by_id: [null],
      test: [""],
      observation_test: [""],
      result_test: [""],
      start_test: [{ value: null, disabled: true }],
      end_test: [{ value: null, disabled: true }],

      documental_analysis_by_id: [null],
      observation_documental_analysis: [""],
      result_documental_analysis: [
        {
          value: "",
          disabled: !this.hasPermission("edit citation documental analysis"),
        },
      ],
      start_documental_analysis: [{ value: null, disabled: true }],
      end_documental_analysis: [{ value: null, disabled: true }],

      referencing_by_id: [null],
      observation_referencing: [""],
      result_referencing: [
        {
          value: "",
          disabled: !this.hasPermission("edit citation referencing"),
        },
      ],
      start_referencing: [{ value: null, disabled: true }],
      end_referencing: [{ value: null, disabled: true }],

      background_validation_by_id: [null],
      observation_background_validation: [""],
      result_background_validation: [
        {
          value: "",
          disabled: !this.hasPermission("edit citation background validation"),
        },
      ],
      start_background_validation: [{ value: null, disabled: true }],
      end_background_validation: [{ value: null, disabled: true }],

      medical_exams_by_id: [null],
      observation_medical_exams: [""],
      result_medical_exams: [""],
      lab_medical_exams: [null],
      start_medical_exams: [{ value: null, disabled: true }],
      end_medical_exams: [{ value: null, disabled: true }],
      come_medical_exams: [{ value: null, disabled: true }],
      date_come_medical_exams: [{ value: null, disabled: true }],
      date_medical_appointment: [null],
      date_medical_appointment_result: [null],
      date_medical_appointment_two: [
        { value: null, disabled: this.existData() },
      ],
      date_medical_appointment_result_two: [
        { value: null, disabled: this.existData() },
      ],
      date_medical_appointment_three: [null],
      date_medical_appointment_result_three: [null],
      send_hiring: [""],
      start_send_hiring: [{ value: null, disabled: true }],

      send_hiring_sign: [""],
      start_send_hiring_sign: [{ value: null, disabled: true }],

      hire_by_id: [null],
      hiring_analyst_id: "",
      manager_send_hiring_sign_by_id: "",
      observation_hire: [""],
      result_hire: [{ value: "", disabled: true }],
      start_hire: [{ value: null, disabled: true }],
      end_hire: [{ value: null, disabled: true }],
      accordance_hire: [""],
      observation_hire_accordance: [""],
      cost_center: [""],
      admission_date: [
        {
          value: null,
          disabled: !this.hasPermission("edit citation income order"),
        },
      ],
      retirement_date: [
        {
          value: null,
          disabled: !this.hasPermission("edit citation income order"),
        },
      ],
      suggested_date_medical_exam: [
        {
          value: "",
          disabled: !this.hasPermission("edit citation income order"),
        },
      ],
      salary_type: [""],
      person_labor: [""],
      person_arl: [""],
      person_additional_requirements: [""],

      second_accordance_hire: [""],
      external_error_hire: [""],
      internal_error_hire: [""],
      treatment_hire: [""],
      verify_hire_by_id: [""],
      approval_hire_by_id: [""],

      // 'updated_by_id': [''],
      requisition_id: [{ value: "", disabled: true }],
      state_backup: [""],
      observation_backup: [""],
      salary: ["", Validators.compose([Validators.pattern("^[0-9.,]*$")])],

      // 'hiring_reason_description': [ {value: null, disabled: true}, Validators.compose([ Validators.minLength(2) ])],
      // 'temporary_hiring_reason': [ {value: null, disabled: true}, Validators.compose([ Validators.minLength(1) ]) ],
      salary_modality: [null],
      payment_type: [""],
      modality: [null],

      extralegal_benefits: [
        "",
        Validators.compose([Validators.maxLength(500)]),
      ],
      workplace: [""],
      working_day: [""],
      working_day_other: [""],
      commissions: [null],

      filing_date: [{ value: "", disabled: true }],
      employee_city_id: [""],
      start_send_income_order: null,
      first_day_instruction: undefined,

      customer_approved_id: ["0"],
      authorization_observations: [
        null,
        Validators.compose([Validators.maxLength(500)]),
      ],
    });

    this.notifyCustomerform = fb.group({
      customer_email: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.pattern(
            "^[a-z0-9]+(.[_a-z0-9]+)*@[a-z0-9-]+(.[a-z0-9-]+)*(.[a-z]{2,15})$"
          ),
        ]),
      ],
      customer_whatsApp: [
        "",
        Validators.compose([
          Validators.minLength(7),
          Validators.maxLength(10),
          Validators.pattern("^[0-9]*$"),
        ]),
      ],
    });
  }

  ngOnInit() {
    // if(this.edit)
    //this.updateFieldsForm(this.edit);
    // else {
    //     if (this.idCitation) {
    //         const filters = [];
    //         filters.push({'key': 'id', 'value': this.idCitation});
    //         this.getCitations(undefined, filters);
    //     }
    // }
    this.form.get("result_referencing").valueChanges.subscribe((value) => {
      this.exclusionReferencing = this.observerValueExclusionCandidate(
        value,
        "referencing"
      );
    });
    this.form
      .get("result_background_validation")
      .valueChanges.subscribe((value) => {
        this.exclusionBackgroundValidation =
          this.observerValueExclusionCandidate(value, "background_validation");
      });
    this.form
      .get("result_documental_analysis")
      .valueChanges.subscribe((value) => {
        this.exclusionDocumentalAnalysis = this.observerValueExclusionCandidate(
          value,
          "documental_analysis"
        );
      });
    this.form.get("result_medical_exams").valueChanges.subscribe((value) => {
      this.exclusionMedicalExams = this.observerValueExclusionCandidate(
        value,
        "medical_exams"
      );
    });
  }

  observerValueExclusionCandidate(obj, name) {
    var variableForShowForm = false;
    var name_edit = "result_" + name;
    var name_form = "exclusion_" + name;
    // Dependiendo del valor seleccionado, muestra u oculta el FormGroup adicional
    if (obj != null && obj != "") {
      if (obj.value === "No Apto") {
        if (this.edit) {
          if (this.edit[name_edit] != "No Apto") {
            variableForShowForm = true;
          }
        }
      } else {
        variableForShowForm = false;
        if (this.form.get(name_form)) {
          this.form.removeControl(name_form);
        }
      }
    }
    return variableForShowForm;
  }

  ngOnChanges() {
    this.currentRoleId = JSON.parse(
      localStorage.getItem("profile")
    ).roles[0].id;

    if (this.idCitation || this.edit) {
      // if(this.edit){
      this.recoveryShowData();
      if (this.minimum == undefined) {
        this.citationService
          .infoCitation(this.edit.id, null)
          .toPromise()
          .then(
            (response) => {
              this.edit = response.json();
              this.updateFieldsForm(this.edit);
              this.validationSomeFields(this.requisition.company_id.toString());
              this.validationGetCandidate(
                this.minimum,
                this.editPart,
                this.edit.candidate_id
              );
              this.showPage = true;
            },
            (error) => {
              this.notificationsService.growlNotify(
                "error",
                "ID " + this.edit.id + " no encontrado"
              );
              this.cancelCitation();
            }
          );
      } else {
        this.updateFieldsForm(this.edit);
        this.validationSomeFields(this.requisition.company_id.toString());
        this.validationGetCandidate(
          this.minimum,
          this.editPart,
          this.edit.candidate_id
        );
        this.showPage = true;
      }

      // const filters = [];
      // filters.push({'key': 'id', 'value': this.idCitation});
      // this.getCitations(undefined, filters);
    } else {
      this.getRequisition(this.idRequisition);
      this.showPage = true;
    }
  }

  public cancelCitation() {
    console.log("reset");
    this.form.reset();
    this.close.emit(true);
  }

  public validationCandidate() {
    let candidate_id = this.form.get("candidate_id").value.id;
    // this.form.value.candidate_id.id;

    this.candidateCommentService
      .validationCandidateId(candidate_id)
      .toPromise()
      .then(
        (response) => {
          let responseCandidate = response.json();
          this.exclusion = responseCandidate.result;
          if (this.exclusion == true) {
            this.confirmationDialogMode = "candidate_creation";
            this.confirmationDialogMessage =
              "El candidato seleccionado tiene una exclusión de contratación. ¿Está seguro que quiere continuar?";
            this.modConfirmationDialog = true;
          } else {
            this.modConfirmationDialog = false;
            this.newCitation(null);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public submitCitation() {
    if (!this.edit) {
      this.validationCandidate();
    } else {
      this.newCitation(null);
    }
  }

  public confirmationNewCitation() {
    this.modConfirmationDialog = false;

    if (
      this.confirmationDialogMode === "send_documental_management" &&
      this.pendingSendDocumentalPayload
    ) {
      const payload = {
        ...this.pendingSendDocumentalPayload,
        force_exclusion_process: 1,
      };
      this.pendingSendDocumentalPayload = null;
      this.promiseSubmit(payload);
      return;
    }

    this.confirmation = true;
    this.newCitation(null);
  }

  public cancelConfirmationDialog() {
    this.modConfirmationDialog = false;
    this.pendingSendDocumentalPayload = null;
  }

  public promiseSubmit(param) {
    const promise = this.edit
      ? this.citationService.updateCitation(this.edit.id, param)
      : this.citationService.newCitation(param);
    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.pendingSendDocumentalPayload = null;
        this.modConfirmationDialog = false;
        this.translate.get("saved").subscribe((res: string) => {
          this.notificationsService.growlNotify("success", res);
          // this.msg.emit( { severity: 'success', summary: res  } );
          this.close.emit(true);
          this.form.reset();
        });
      },
      (error) => {
        const parsedError = this.parseApiError(error);
        const body = parsedError.body;

        if (
          body &&
          body.status === "confirmation_required" &&
          body.requires_confirmation === true
        ) {
          this.confirmationDialogMode = "send_documental_management";
          this.confirmationDialogMessage =
            body.message ||
            "El candidato tiene una exclusión. ¿Desea continuar?";
          this.pendingSendDocumentalPayload = { ...param };
          this.modConfirmationDialog = true;
          return;
        }

        const msg_error = parsedError.message || "Error guardando operación";
        this.notificationsService.growlNotify("error", msg_error);
      }
    );
  }

  private parseApiError(error: any): { body: any; message: string } {
    let body: any = null;
    let message = "";

    try {
      if (error && error._body) {
        body = JSON.parse(error._body);
      } else if (error && error.error) {
        body =
          typeof error.error === "string"
            ? JSON.parse(error.error)
            : error.error;
      }
    } catch (e) {
      body = null;
    }

    if (body && body.message) {
      message = body.message;
    } else if (error && typeof error._body === "string") {
      message = error._body;
    } else {
      message = "Error guardando operación";
    }

    return { body, message };
  }

  public newCitation(values: any) {
    this.enableReqControls();
    this.enableDateControls();
    values = this.form.value;

    this.sendRequestToAnotherSites(values);

    values.management = values.management ? values.management.value : undefined;
    values.source = values.source ? values.source.value : undefined;
    values.date_citations = values.date_citations
      ? formatDate(values.date_citations)
      : formatDate(new Date().toISOString());
    values.recruited_at = values.recruited_at
      ? formatDate(values.recruited_at)
      : null;
    values.recruited_accepted_at = values.recruited_accepted_at
      ? formatDate(values.recruited_accepted_at)
      : values.recruited == "1"
      ? values.recruited_at
      : null;
    values.withdrawal = values.withdrawal ? values.withdrawal.value : undefined;
    values.withdrawal_reason = values.withdrawal
      ? values.withdrawal_reason
        ? values.withdrawal_reason.value
        : undefined
      : undefined;
    // values.withdrawal_reason = (values.withdrawal) ? values.withdrawal_reason.value : undefined;
    values.withdrawal_observations = values.withdrawal
      ? values.withdrawal_observations
      : undefined;

    values.admission_date = values.admission_date
      ? formatDate(values.admission_date)
      : undefined;
    values.retirement_date = values.retirement_date
      ? formatDate(values.retirement_date)
      : undefined;
    values.date_medical_appointment = values.date_medical_appointment
      ? formatDate(values.date_medical_appointment)
      : null;
    values.date_medical_appointment_result =
      values.date_medical_appointment_result
        ? formatDate(values.date_medical_appointment_result)
        : null;
    values.date_medical_appointment_two = values.date_medical_appointment_two
      ? formatDate(values.date_medical_appointment_two)
      : null;
    values.date_medical_appointment_result_two =
      values.date_medical_appointment_result_two
        ? formatDate(values.date_medical_appointment_result_two)
        : null;
    values.date_medical_appointment_three =
      values.date_medical_appointment_three
        ? formatDate(values.date_medical_appointment_three)
        : null;
    values.date_medical_appointment_result_three =
      values.date_medical_appointment_result_three
        ? formatDate(values.date_medical_appointment_result_three)
        : null;

    values.filing_date = values.filing_date
      ? formatDate(values.filing_date)
      : undefined;
    values.suggested_date_medical_exam = values.suggested_date_medical_exam
      ? formatDate(values.suggested_date_medical_exam)
      : undefined;

    // ============ VALIDACIÓN DE FECHA DE ADMISIÓN ============
    // Validar si admission_date es menor a la fecha actual
    if (values.admission_date && values.customer_approved_id
        && (values.customer_approved_id == '2' || values.customer_approved_id == '4')
        && values.result_hire == '') {
      const admissionDate = new Date(values.admission_date);
      const currentDate = new Date();

      // Normalizar las fechas para comparar solo año, mes y día (sin horas)
      admissionDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (admissionDate < currentDate) {
        // Mostrar diálogo de error y cancelar el proceso

        this.showDateValidationDialog = true;

        // Salir del método sin continuar con el proceso
        return;
      }
    }
    // ============ FIN DE VALIDACIÓN ============

    this.assignValue(values, "recruited_by_id", this.getValueById);
    this.assignValue(values, "elaborated_by_id", this.getValueById);
    this.assignValue(values, "called_by_id", this.getValueById);
    this.assignValue(values, "candidate_id", this.getValueById);

    this.setValuesGroup(
      values,
      "interviewed",
      values.result_interview,
      this.resultOptionsSelection
    );
    this.setValuesGroup(
      values,
      "tested",
      values.result_test,
      this.resultOptions
    );
    this.setValuesGroup(
      values,
      "documental_analysis",
      values.result_documental_analysis,
      this.resultOptionsDocumental
    );
    this.setValuesGroup(
      values,
      "referencing",
      values.result_referencing,
      this.resultOptionsReferencing
    );
    this.setValuesGroup(
      values,
      "background_validation",
      values.result_background_validation,
      this.resultOptionsReferencing
    );
    this.setValuesGroup(
      values,
      "medical_exams",
      values.result_medical_exams,
      this.resultOptionsMedical
    );
    this.setValuesGroup(
      values,
      "send_customer",
      values.result_send_customer,
      this.resultOptions
    );
    this.setValuesGroup(
      values,
      "hire",
      values.result_hire,
      this.resultOptionsHire
    );

    this.assignValue(values, "hiring_analyst_id", this.getValueById);

    this.assignValue(values, "lab_medical_exams", this.getValueById);

    this.assignValue(
      values,
      "manager_send_hiring_sign_by_id",
      this.getValueById
    );

    // values.temporary_hiring_reason = values.temporary_hiring_reason.value;

    values.salary_modality = values.salary_modality
      ? values.salary_modality.value
      : undefined;
    values.payment_type = values.payment_type || "";
    values.modality = values.modality ? values.modality.value : undefined;
    values.working_day = values.working_day
      ? values.working_day.value
      : "";
    values.commissions = values.commissions
      ? values.commissions.value
      : undefined;

    values.filling_date = values.filling_date
      ? formatDate(values.filling_date)
      : null;
    this.assignValue(values, "employee_city_id", this.getValueById);

    delete values.force_exclusion_process;

    values.salary = values.salary.replace(/[\.,]/g, "");

    values.customer_approved_id = this.sendResponseCustomerApprovedID(
      this.edit ? this.edit.customer_approved_id : null,
      values.customer_approved_id
    );
    // let approval_hire_by_id;
    // let verify_hire_by_id;
    // let updated_by_id;

    if (values) {
      if (this.minimum) {
        this.edit.id = Number(this.idCitation);
      }

      var param = this.sendValuesPart(values);

      if (this.edit || this.exclusion == false || this.confirmation == true) {
        this.promiseSubmit(param);
      }
    }
  }

  closeDateValidationDialog(): void {
    this.showDateValidationDialog = false;
  }

  sendRequestToAnotherSites(values: any) {
    // Verifica si es un pedido de ingreso y asigna la fecha si es necesario
    if (this.minimum && this.editPart === "income_order") {
      this.sendCandidateSorttime();
      values.start_send_income_order =
        values.start_send_income_order || formatDate(new Date().toISOString());
    }

    // Verifica si el resultado del cliente es "Favorable" o "Autorizado" para enviar a botzy
    this.checkAndSendCustomerResult(values);

    // Verifica si el resultado de la contratación es "Contratado" para enviar a botzy
    this.checkAndSendHireResult(values);
  }

  checkAndSendCustomerResult(values: any) {
    const favorable_or_authorized = ["Favorable", "Autorizado"];
    const status_rejected = ["No Apto", "No Contestó", "No asistió"];
    const result_send_customer = values.result_send_customer
      ? values.result_send_customer.value
      : null;
    const result_interview = values.result_interview
      ? values.result_interview.value
      : null;

    // Verifica si el resultado de la entrevista es "Favorable" o "Autorizado" y realiza la lógica existente
    if (favorable_or_authorized.includes(result_interview)) {
      if (
        this.edit &&
        !favorable_or_authorized.includes(this.edit.result_interview)
      ) {
        this.sendInformationtoBotzy(this.edit);
      }
    }
    if (
      status_rejected.includes(result_interview) ||
      status_rejected.includes(result_send_customer)
    ) {
      // Verifica si result_interview o result_send_customer tienen un valor diferente y no son nulos
      if (
        (result_interview &&
          this.edit &&
          result_interview !== this.edit.result_interview) ||
        (result_send_customer &&
          this.edit &&
          result_send_customer !== this.edit.result_send_customer)
      ) {
        this.sendInfoCandidateRejectedBotzy(this.edit);
      }
    }
  }

  checkAndSendHireResult(values: any) {
    const resultHire = values.result_hire ? values.result_hire.value : null;

    if (resultHire === "Contratado") {
      if (this.edit && this.edit.result_hire !== "Contratado") {
        this.sendHireInformationtoBotzy(this.edit);
      }
    }
  }

  setValuesGroup(
    values: any,
    name: string,
    result: any,
    resultOptionsSelection: SelectItem[]
  ) {
    this.assignValue(values, name + "_by_id", this.getValueById);
    if (name == "interviewed") name = "interview";
    if (name == "tested") name = "test";
    this.assignDateByStatus(
      values,
      this.edit,
      "start_" + name,
      result,
      resultOptionsSelection
    );
    this.assignDateByStatus(
      values,
      this.edit,
      "end_" + name,
      result,
      resultOptionsSelection
    );
    this.assignResultValue(values, "result_" + name, this.validateResult);
  }
  enableReqControls() {
    this.form.get("requisition_id").enable();
    this.form.get("requisition_observation").enable();
    // this.form.get('temporary_hiring_reason').enable();
    // this.form.get('hiring_reason_description').enable();
  }
  enableDateControls() {
    this.enablePairControls("interview");
    this.enablePairControls("test");
    this.enablePairControls("documental_analysis");
    this.enablePairControls("referencing");
    this.enablePairControls("background_validation");
    this.enablePairControls("medical_exams");
    this.enablePairControls("send_customer");
    this.enablePairControls("hire");
  }
  enablePairControls(name: string) {
    const startControl = this.form.get("start_" + name);
    const endControl = this.form.get("end_" + name);

    if (startControl) {
      startControl.enable();
    }

    if (endControl) {
      endControl.enable();
    }
  }
  validationGetCandidate(
    minimum: boolean,
    editPart: string,
    candidate_id: number
  ) {
    if (minimum && editPart == "income_order") {
      var promiseLoc = this.candidateService
        .infoCandidateRelations(candidate_id)
        .toPromise()
        .then(
          (response) => {
            this.candidate = response.json();
          },
          (error) => {
            this.notificationsService.growlNotify(
              "error",
              "Candidato " + candidate_id + " no encontrado"
            );
          }
        );
      this.getDisableFieldsAdmissionDate(this.edit.customer_approved_id);
    }
  }

  validationSomeFields(company_id: string) {
    var companies = [
      "288",
      "290",
      "287",
      "286",
      "306",
      "305",
      "310",
      "304",
      "309",
      "314",
      "614",
      "302",
    ];
    var res_bool = companies.includes(company_id);
    if (
      res_bool &&
      (this.editPart == "medical_exams" || this.editPart == "allinone")
    ) {
      this.updateValidator("cost_center");
    }
    if (this.editPart != "" && this.editPart != undefined) {
      var arrayControls = this.chooseArrayRequiredControls(this.editPart);
      arrayControls.forEach((element) => {
        this.updateValidator(element);
      });
    }
    if (this.edit.result_medical_exams == "No Apto")
      this.form.get("result_medical_exams").disable();

    enableChangeResult(
      this.getRoleId(),
      this.rolesPermissionChangeHire,
      this.edit.result_hire,
      "result_hire",
      this.form
    );

    if (this.edit.source != "" || this.edit.source != null) {
      this.form.get("source").clearValidators();
      this.form.get("source").updateValueAndValidity();
      this.form.controls["source"].disable();
    }
  }

  chooseArrayRequiredControls(editPart: string) {
    var select_array = [];
    var options_edit_part = [
      // "interview",
      "test",
      "documental_analysis",
      "referencing",
      "background_validation",
      "medical_exams",
      "send_customer",
    ]; //'citation', 'hire'
    if (options_edit_part.includes(editPart)) {
      // if(editPart == 'interview') editPart = 'interviewed';
      select_array = ["result_" + editPart]; //editPart+'_by_id'
    }
    if (editPart == "income_order") {
      select_array = [
        "suggested_date_medical_exam",
        "admission_date",
        // 'retirement_date',
        "cost_center",
        "person_arl",
        "person_labor",
        "workplace",
        "working_day",
        "modality",
        "salary",
        "salary_type",
        "salary_modality",
        "payment_type",
        // 'extralegal_benefits',
      ];
    }

    return select_array;
  }

  updateValidator(name: string) {
    if (name == "salary")
      this.form
        .get(name)
        .setValidators([
          Validators.required,
          Validators.minLength(1),
          Validators.pattern("^[0-9.,]*$"),
        ]);
    else if (name == "emergency_contact_number")
      this.form
        .get(name)
        .setValidators([
          Validators.required,
          Validators.minLength(1),
          Validators.pattern("^[0-9]*$"),
        ]);
    else
      this.form
        .get(name)
        .setValidators([Validators.required, Validators.minLength(1)]);

    this.form.get(name).updateValueAndValidity();
  }

  validateResult(result: any): any {
    var res = false;
    if (result != "") {
      if (result != null) res = true;
    }
    return res;
  }

  validationOptionInsideArray(options: any[], result: any) {
    var res = false;
    if (options.length > 0) {
      res = options.some((option) => {
        return option.value == result.value;
      });
    }
    return res;
  }

  getDateByStatus(
    edit_date: any,
    result: any,
    options: any[],
    current_date: any
  ): any {
    var date = null;
    if (edit_date) date = edit_date;
    else {
      if (result) {
        var res = this.validationOptionInsideArray(options, result); // var res = options.includes(result);
        if (res) {
          if (!current_date) date = formatDate(new Date().toISOString());
          else date = formatDate(current_date);
        }
      }
    }
    return date;
  }

  getValueById(var_by_id: any): any {
    var ret_id = undefined;
    if (var_by_id) {
      if (var_by_id.id) {
        ret_id = var_by_id.id;
      } else {
        ret_id = var_by_id;
      }
    }
    return ret_id;
  }

  public assignValue(values, property, getValueFn) {
    if (values.hasOwnProperty(property)) {
      values[property] = getValueFn(values[property]);
    }
  }

  public assignDateByStatus(
    values,
    edit,
    property,
    resultValue,
    resultOptions
  ) {
    if (values.hasOwnProperty(property)) {
      // if(values[property] != undefined)
      values[property] = this.getDateByStatus(
        edit ? edit[property] : null,
        resultValue,
        resultOptions,
        values[property]
      );
    }
  }

  public assignResultValue(values, property, validateFn) {
    if (values.hasOwnProperty(property)) {
      values[property] = validateFn(values[property])
        ? values[property].value
        : null;
    }
  }

  public existData() {
    var status = false;
    if (this.edit) {
      if (this.edit.date_medical_appointment_three) status = true;
    }
    return status;
  }

  public selectedCompany(values) {
    if (values.customer_guide) {
      this.customer_guide_id = values.customer_guide.id;
    }
  }

  public showNewCandidateDialog() {
    // this.identification_number.setValue('');
    // this.identification_number.enable();
    // this.name.setValue('');
    // this.name.enable();
    // this.email.setValue('');
    // this.email.enable();
    // this.phone.setValue('');
    // this.phone.enable();
    // this.mobile.setValue('');
    // this.mobile.enable();
    this.modViewDialog = true;
  }

  //   public confirmation() {
  //     this.needConfirmation = true;
  //     return this.needConfirmation;
  //   }

  public showSpeechTextDialog() {
    this.modViewSpeechTextDialog = true;
  }

  public gotoProfileSurvey() {
    let profile_survey_id = this.requisition.profile_survey_small.id;
    window.open(
      "/pages/selection/profile-surveis/" +
        profile_survey_id +
        "?token=" +
        localStorage.getItem("token")
    );
    return false;
  }

  public getRequisition(query?: string, filtersReceived?: any[]) {
    const filters = [];
    if (filtersReceived) {
      filtersReceived.forEach((element) => {
        if (element.value) {
          filters.push({ key: element.key, value: element.value });
        }
      });
    }
    var _with = "profile_survey_small,customer_guide_small,venue,company";
    this.requisitionService
      .infoRequisition(Number(query), _with)
      .toPromise()
      .then(
        // this.requisitionService.getRequisition(1, 1, undefined, query, filters).toPromise().then(
        (response) => {
          this.requisition = response.json();
          this.form.get("requisition_id").setValue(this.requisition.id);
          this.form
            .get("salary")
            .setValue(
              this.isNumberSalary(this.requisition.profile_survey_small.salary)
            );
          this.form
            .get("cost_center")
            .setValue(this.requisition.center_cost);
          this.form
            .get("person_labor")
            .setValue(this.requisition.profile_survey_small.employee_position);
          this.form
            .get("person_arl")
            .setValue(this.requisition.profile_survey_small.risk);
          this.form
            .get("payment_type")
            .setValue(
              this.requisition.profile_survey_small.salary_payment_method
            );
          this.form
            .get("working_day")!
            .setValue(
              this.workingDayOptions.find(
                (option) =>
                  option.value ==
                  this.requisition.profile_survey_small.workday_schedule
              )
            );
          this.form
            .get("working_day_other")!
            .setValue(this.requisition.profile_survey_small.workday_detail);
          this.form
            .get("first_day_instruction")
            .setValue(
              this.requisition.customer_guide_small.first_day_instruction
            );
          this.show_temporary_hiring_reason =
            this.requisition.temporary_hiring_reason;
          this.show_hiring_reason_description =
            this.requisition.hiring_reason_description;
          this.show_venue = this.requisition.venue.name;
          this.show_company = this.requisition.company.name;
          this.show_observation = this.requisition.observation;
          this.show_profile_survey =
            this.requisition.profile_survey_small.employee_position;

          this.show_profile_survey_small =
            this.requisition.profile_survey_small;

          // this.form.get('temporary_hiring_reason').setValue(this.requisition.temporary_hiring_reason);
          // this.form.get('hiring_reason_description').setValue(this.requisition.hiring_reason_description);
        },
        (error) => {
          this.msgs = [];
          this.msgs.push({
            severity: "error",
            summary: "error get requisition",
          });
        }
      );
  }

  public getCitations(query?: string, filtersReceived?: any[]) {
    const filters = [];
    if (filtersReceived) {
      filtersReceived.forEach((element) => {
        if (element.value) {
          filters.push({ key: element.key, value: element.value });
        }
      });
    }

    this.citationService
      .getCitation(1, 1, undefined, query, filters)
      .toPromise()
      .then(
        (response) => {
          const citations = response.json().data;
        },
        (error) => {
          // this.msgs = [];
          // this.msgs.push( { severity: 'error', summary: 'error' } );
        }
      );
  }

  public showResultNewCandidate(msg) {
    this.messages = [];
    this.messages.push(msg);
  }

  public getNewCandidate(candidate) {
    console.log(candidate);
    this.modViewDialog = false;
    if (candidate) {
      if (candidate.id) {
        this.new_candidate_id = candidate.id;
        this.form.get("candidate_id").setValue(candidate);
      }
    }
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public onUploadFileTest(event: any) {
    this.uploadedFileTest = [];
    for (const file of event.srcElement.files) {
      this.uploadedFileTest.push(file);
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewFileTest = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public updateFileTest(event: any) {
    this.uploadedFileTest = [];
    for (const file of event.files) {
      this.uploadedFileTest.push(file);
    }

    this.promiseFileTest = this.uploadFilesService
      .updateFileTest(this.uploadedFileTest, this.edit.id)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
          // this.getProfile();
          // this.avatar = this.prewiewFileTest;
        },
        (error) => {
          let errorMsg = "";
          errorMsg = "Error";
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: errorMsg });
        }
      );
  }

  public gotoFileTest() {
    window.open(
      this.apiUrl + "/citations/" + this.edit.id + "/file-test",
      "_blank"
    );
  }

  public downloadFileTest() {
    this.promiseFileTest = this.uploadFilesService
      .getFileTest(this.edit.id)
      .toPromise()
      .then(
        (response) => {},
        (error) => {
          let errorMsg = "";
          errorMsg = "Error";
          this.msgs = [];
          this.msgs.push({ severity: "error", summary: errorMsg });
        }
      );
  }

  getFormValidationErrors(form) {
    let value = "";
    Object.keys(form.controls).forEach((key) => {
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach((keyError) => {
          value =
            "Key control: " +
            key +
            ", keyError: " +
            keyError +
            ", err value: " +
            controlErrors[keyError];
        });
      }
    });
    return value;
  }

  public checkOtherValidation(values) {
    let check = false;
    if (values) {
      if (values.candidate_id) {
        if (values.candidate_id != "" && values.candidate_id != null) {
          check = true;
        }
        // if (values.candidate_id.id) {
        //     check = true;
        // } else {
        //     return false;
        // }
      }
    }
    if (this.minimum && this.editPart == "income_order") {
      if (this.candidate == undefined) check = false;
    }
    return check;
  }

  public updateFieldsForm(input: any) {
    this.form.patchValue({
      read: this.edit.read,
      candidate_id: this.edit.candidate_id,
      // requisition_observation: this.edit.requisition.observation,
      management: this.managementOptions.find(
        (option) => option.value == this.edit.management,
      ),
      source: this.sourceOptions.find(
        (option) => option.value == this.edit.source,
      ),

      date_citations: this.edit.date_citations
        ? new Date(this.edit.date_citations)
        : null,
      admission_date: this.edit.admission_date
        ? new Date(this.edit.admission_date)
        : null,
      retirement_date: this.edit.retirement_date
        ? new Date(this.edit.retirement_date)
        : null,
      suggested_date_medical_exam: this.edit.suggested_date_medical_exam
        ? new Date(this.edit.suggested_date_medical_exam)
        : null,

      withdrawal: this.withdrawalOptions.find(
        (option) => option.value == this.edit.withdrawal,
      ),
      withdrawal_reason: this.withdrawalReasonOptions.find(
        (option) => option.value == this.edit.withdrawal_reason,
      ),
      withdrawal_observations: this.edit.withdrawal_observations,

      recruited: this.edit.recruited,
      recruited_accepted: this.edit.recruited_accepted,
      recruited_accepted_at: this.edit.recruited_accepted_at,
      recruited_at: this.edit.recruited_at
        ? new Date(this.edit.recruited_at)
        : null,
      recruited_by_id: this.edit.recruited_by_id,
      called_by_id: this.edit.called_by_id,
      observation_citation: this.edit.observation_citation,
      attended: this.edit.attended,

      send_customer_by_id: this.edit.send_customer_by,
      observation_send_customer: this.edit.observation_send_customer,
      result_send_customer: this.resultOptions.find(
        (option) => option.value == this.edit.result_send_customer,
      ),
      start_send_customer: this.edit.start_send_customer
        ? new Date(this.edit.start_send_customer)
        : null,
      end_send_customer: this.edit.end_send_customer
        ? new Date(this.edit.end_send_customer)
        : null,

      tested_by_id: this.edit.tested_by,
      test: this.edit.test,
      observation_test: this.edit.observation_test,
      result_test: this.resultOptions.find(
        (option) => option.value == this.edit.result_test,
      ),
      start_test: this.edit.start_test ? new Date(this.edit.start_test) : null,
      end_test: this.edit.end_test ? new Date(this.edit.end_test) : null,

      documental_analysis_by_id: this.edit.documental_analysis_by,
      observation_documental_analysis:
        this.edit.observation_documental_analysis,
      result_documental_analysis: this.resultOptionsDocumental.find(
        (option) => option.value == this.edit.result_documental_analysis,
      ),

      start_documental_analysis: this.edit.start_documental_analysis
        ? new Date(this.edit.start_documental_analysis)
        : null,
      end_documental_analysis: this.edit.end_documental_analysis
        ? new Date(this.edit.end_documental_analysis)
        : null,

      referencing_by_id: this.edit.referencing_by,
      observation_referencing: this.edit.observation_referencing,
      result_referencing: this.resultOptionsReferencing.find(
        (option) => option.value == this.edit.result_referencing,
      ),
      start_referencing: this.edit.start_referencing
        ? new Date(this.edit.start_referencing)
        : null,
      end_referencing: this.edit.end_referencing
        ? new Date(this.edit.end_referencing)
        : null,

      background_validation_by_id: this.edit.background_validation_by_id,
      observation_background_validation:
        this.edit.observation_background_validation,
      result_background_validation: this.resultOptions.find(
        (option) => option.value == this.edit.result_background_validation,
      ),
      start_background_validation: this.edit.start_background_validation
        ? new Date(this.edit.start_background_validation)
        : null,
      end_background_validation: this.edit.end_background_validation
        ? new Date(this.edit.end_background_validation)
        : null,

      medical_exams_by_id: this.edit.medical_exams_by,
      observation_medical_exams: this.edit.observation_medical_exams,
      result_medical_exams: this.resultOptionsMedical.find(
        (option) => option.value == this.edit.result_medical_exams,
      ),
      lab_medical_exams: this.edit.lab_medical_exams,
      start_medical_exams: this.edit.start_medical_exams
        ? new Date(this.edit.start_medical_exams)
        : null,
      end_medical_exams: this.edit.end_medical_exams
        ? new Date(this.edit.end_medical_exams)
        : null,
      date_come_medical_exams: this.edit.date_come_medical_exams
        ? new Date(this.edit.date_come_medical_exams)
        : null,
      date_medical_appointment: this.edit.date_medical_appointment
        ? new Date(this.edit.date_medical_appointment)
        : null,
      date_medical_appointment_result: this.edit.date_medical_appointment_result
        ? new Date(this.edit.date_medical_appointment_result)
        : null,
      date_medical_appointment_two: this.edit.date_medical_appointment_two
        ? new Date(this.edit.date_medical_appointment_two)
        : null,
      date_medical_appointment_result_two: this.edit
        .date_medical_appointment_result_two
        ? new Date(this.edit.date_medical_appointment_result_two)
        : null,
      date_medical_appointment_three: this.edit.date_medical_appointment_three
        ? new Date(this.edit.date_medical_appointment_three)
        : null,
      date_medical_appointment_result_three: this.edit
        .date_medical_appointment_result_three
        ? new Date(this.edit.date_medical_appointment_result_three)
        : null,

      send_hiring: this.edit.send_hiring,
      start_send_hiring: this.edit.start_send_hiring
        ? new Date(this.edit.start_send_hiring)
        : null,

      send_hiring_sign: this.edit.send_hiring_sign,
      start_send_hiring_sign: this.edit.start_send_hiring_sign
        ? new Date(this.edit.start_send_hiring_sign)
        : null,

      hire_by_id: this.edit.hire_by_id,
      hiring_analyst_id: this.edit.hiring_analyst_id,
      manager_send_hiring_sign_by_id: this.edit.manager_send_hiring_sign_by_id,
      observation_hire: this.edit.observation_hire,
      result_hire: this.resultOptionsHire.find(
        (option) => option.value == this.edit.result_hire,
      ),
      start_hire: this.edit.start_hire ? new Date(this.edit.start_hire) : null,
      end_hire: this.edit.end_hire ? new Date(this.edit.end_hire) : null,

      accordance_hire: this.edit.accordance_hire,
      observation_hire_accordance: this.edit.observation_hire_accordance,
      cost_center: this.edit.cost_center || this.requisition.center_cost,
      person_labor: this.edit.person_labor,
      person_arl: this.edit.person_arl,
      person_additional_requirements: this.edit.person_additional_requirements,
      salary_type: this.edit.salary_type,
      salary: this.isNumberSalary(this.edit.salary),

      // hiring_reason_description : this.edit.requisition.hiring_reason_description,
      // temporary_hiring_reason : this.temporaryHiringReasonOptions.find((option) => option.value == this.edit.requisition.temporary_hiring_reason),
      salary_modality: this.salaryModalityOptions.find(
        (option) => option.value == this.edit.salary_modality,
      ),
      // payment_type: this.paymentTypeOptions.find(
      //   (option) => option.value == this.edit.payment_type
      // ),
      // payment_type: this.edit && this.edit.payment_type ? this.edit.payment_type.trim() : "",
      // modality: this.modalityOptions.find(
      //   (option) => option.value == this.edit.modality
      // ),
      payment_type:
        this.edit && this.edit.payment_type
          ? this.edit.payment_type.trim()
          : this.requisition &&
            this.requisition.profile_survey_small &&
            this.requisition.profile_survey_small.salary_payment_method
          ? this.requisition.profile_survey_small.salary_payment_method
          : "",
      working_day: this.workingDayOptions.find(
        (option) =>
          option.value ==
          (this.edit.working_day ||
            (this.requisition &&
              this.requisition.profile_survey_small &&
              this.requisition.profile_survey_small.workday_schedule)),
      ),
      commissions: this.commissionsOptions.find(
        (option) => option.value == this.edit.commissions,
      ),

      extralegal_benefits: this.edit.extralegal_benefits,
      workplace: this.edit.workplace,
      working_day_other:
        this.edit.working_day_other ||
        (this.requisition &&
          this.requisition.profile_survey_small &&
          this.requisition.profile_survey_small.workday_detail) ||
        "",

      filing_date: this.edit.filing_date
        ? new Date(this.edit.filing_date)
        : null,
      employee_city_id: this.edit.employee_city_id,

      second_accordance_hire: this.edit.second_accordance_hire,
      external_error_hire: this.edit.external_error_hire,
      internal_error_hire: this.edit.internal_error_hire,
      treatment_hire: this.edit.treatment_hire,
      verify_hire_by_id: this.edit.verify_hire_by_id,
      approval_hire_by_id: this.edit.approval_hire_by_id,

      // this.updated_by_id.setValue(this.edit.updated_by);
      requisition_id: this.edit.requisition_id,

      state_backup: this.edit.state_backup,
      observation_backup: this.edit.observation_backup,
      start_send_income_order: this.edit.start_send_income_order,

      first_day_instruction: this.edit.first_day_instruction,

      customer_approved_id: this.changeStatusCustomerApprovedID(
        this.edit.customer_approved_id,
      ),
      authorization_observations: this.edit.authorization_observations,
    });

    if (
      !this.edit.payment_type ||
      !this.edit.working_day ||
      !this.edit.working_day_other
    ) {
      this.loadDefaultsFromProfileSurvey();
    }

    if (this.edit.file_test) {
      this.uploadedFileTest = [];
      this.uploadedFileTest.push({ name: "Archivo Adjunto  " });
    }
    this.notifyCustomerform.patchValue({
      customer_whatsApp:
        this.requisition.customer_guide_selection_contact
          .selection_contact_mobile,
      customer_email:
        this.requisition.customer_guide_selection_contact
          .selection_contact_email,
    });
  }

  public loadDefaultsFromProfileSurvey() {
    const requisition_id = this.edit && this.edit.requisition_id;
    if (!requisition_id) return;

    this.requisitionService
      .infoRequisition(requisition_id, "profile_survey_small")
      .toPromise()
      .then((response) => {
        const profile_survey_small = response.json().profile_survey_small;
        if (!profile_survey_small) return;

        const payment_type_control = this.form.get("payment_type");
        if (
          profile_survey_small.salary_payment_method &&
          payment_type_control &&
          !payment_type_control.value
        ) {
          payment_type_control.setValue(
            profile_survey_small.salary_payment_method
          );
        }

        const working_day_control = this.form.get("working_day");
        if (
          profile_survey_small.workday_schedule &&
          working_day_control &&
          !working_day_control.value
        ) {
          working_day_control.setValue(
            this.workingDayOptions.find(
              (option) => option.value == profile_survey_small.workday_schedule
            )
          );
        }

        const working_day_other_control = this.form.get("working_day_other");
        if (
          profile_survey_small.workday_detail &&
          working_day_other_control &&
          !working_day_other_control.value
        ) {
          working_day_other_control.setValue(
            profile_survey_small.workday_detail
          );
        }
      });
  }

  public isNumberSalary(salary_input: any) {
    var salary_output = "0";
    var noValido = /\s/;

    if (salary_input != null && salary_input != "") {
      if (!noValido.test(salary_input)) {
        if (!isNaN(salary_input)) salary_output = salary_input;
      }
    }

    return salary_output;
  }

  public recoveryShowData() {
    this.requisition = this.edit.requisition;

    this.show_temporary_hiring_reason =
      this.requisition.temporary_hiring_reason;
    this.show_hiring_reason_description =
      this.requisition.hiring_reason_description;
    this.show_observation = this.requisition.observation; //form.controls.requisition_observation.value;

    this.show_venue = this.requisition.venue.name; // this.show_venue = this.requisition.venue.name;
    this.show_company = this.requisition.company.name;
    this.show_profile_survey =
      this.requisition.profile_survey_small.employee_position;
    this.show_candidate = this.edit.candidate.name;

    this.show_profile_survey_small = this.requisition.profile_survey_small;
    this.show_candidate_info = this.edit.candidate;
  }

  public sendCandidateSorttime() {
    let resp = false;
    var paramSorttime = this.paramBuildingCandidateSorttime(this.candidate);
    if (paramSorttime == null) {
      this.translate.get("error").subscribe((res: string) => {
        this.translate.get("candidate").subscribe((res2: string) => {
          this.notificationsService.growlNotify(
            "error",
            res +
              ": " +
              res2 +
              " datos faltantes, no se puede enviar a Sorttime"
          );
        });
      });
      return false;
    }

    const promiseSorttime =
      this.candidateService.sorttimeCandidate(paramSorttime);

    this.promiseForm = promiseSorttime.toPromise().then(
      (response) => {
        resp = true;
        this.translate.get("saved").subscribe((res: string) => {
          this.notificationsService.growlNotify("success", res + " Sorttime");
        });
      },
      (error) => {
        let msg = "Error envío de datos a Sorttime";
        this.notificationsService.growlNotify("error", msg);
      }
    );
    return resp;
  }

  public paramBuildingCandidateSorttime(values: Candidate) {
    var idTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "C. C.", value: "C. C.", code_sorttime: "CIDCCC" },
      { label: "C. E.", value: "C. E.", code_sorttime: "CIDCEE" },
      { label: "T. I.", value: "T. I.", code_sorttime: "CIDTID" },
      { label: "NIT", value: "NIT", code_sorttime: "CIDNIT" },
      { label: "R. C.", value: "R. C.", code_sorttime: "CIDRCI" },
      { label: "P. E.", value: "P. E.", code_sorttime: "CIDPEP" },
      { label: "P. A.", value: "P. A.", code_sorttime: "CIDPAA" },
      { label: "P. T.", value: "P. T.", code_sorttime: "CIDPAS" },
    ];

    var genderOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Femenino", value: "Femenino", code_sorttime: "SEXFEM" },
      { label: "Masculino", value: "Masculino", code_sorttime: "SEXHOM" },
      { label: "No binario", value: "No binario", code_sorttime: "SEXBIN" },
    ];

    var civilStatusOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Soltero(a)", value: "Soltero(a)", code_sorttime: "ECVSOL" },
      { label: "Unión libre", value: "Unión libre", code_sorttime: "ECVLIB" },
      { label: "Casado(a)", value: "Casado(a)", code_sorttime: "ECVCAS" },
      {
        label: "Divorciado(a)",
        value: "Divorciado(a)",
        code_sorttime: "ECVDIV",
      },
      { label: "Separado(a)", value: "Separado(a)", code_sorttime: "ECVSEP" },
      { label: "Viudo(a)", value: "Viudo(a)", code_sorttime: "ECVVIU" },
    ];

    var stratumOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Estrato 1", value: "Estrato 1", code_sorttime: "ETO001" },
      { label: "Estrato 2", value: "Estrato 2", code_sorttime: "ETO002" },
      { label: "Estrato 3", value: "Estrato 3", code_sorttime: "ETO003" },
      { label: "Estrato 4", value: "Estrato 4", code_sorttime: "ETO004" },
      { label: "Estrato 5", value: "Estrato 5", code_sorttime: "ETO005" },
      { label: "Estrato 6", value: "Estrato 6", code_sorttime: "ETO006" },
      { label: "No aplica", value: "No aplica", code_sorttime: "ETO000" }, // Dejar este objeto siempre de último
    ];

    var houseTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Arrendada", value: "Arrendada", code_sorttime: "CLG001" },
      { label: "Familiar", value: "Familiar", code_sorttime: "CLG002" },
      {
        label: "Propia sin hipoteca",
        value: "Propia sin hipoteca",
        code_sorttime: "CLG003",
      },
      {
        label: "Propia con hipoteca",
        value: "Propia con hipoteca",
        code_sorttime: "CLG004",
      },
      {
        label: "No especifica",
        value: "No especifica",
        code_sorttime: "CLG000",
      }, // Dejar este objeto siempre de último
    ];

    var sisbenOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Sí", value: "Sí", code_sorttime: "ING002" },
      { label: "No", value: "No", code_sorttime: "ING001" }, // Dejar este objeto siempre de último
    ];

    var femaleHHOptions = [
      // {label: 'choose', value: '', status_sorttime: ''},
      { label: "Sí", value: "Sí", code_sorttime: true },
      { label: "No", value: "No", code_sorttime: false }, // Dejar este objeto siempre de último
    ];

    var ethnicityOptions = [
      // {label: 'choose', value: '', code_sorttime: '', selected: true},
      { label: "Sí", value: "Sí", code_sorttime: "CCP001", selected: false },
      { label: "No", value: "No", code_sorttime: "CCP000", selected: false }, // Dejar este objeto siempre de último
    ];

    var ethnicGroupOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {
        label: "Afrocolombiano",
        value: "Afrocolombiano",
        code_sorttime: "CCB001",
      },
      { label: "Indígena", value: "Indígena", code_sorttime: "CCB002" },
      { label: "Negro", value: "Negro", code_sorttime: "CCB003" },
      { label: "Palenquero", value: "Palenquero", code_sorttime: "CCB005" },
      { label: "Raizal", value: "Raizal", code_sorttime: "CCB004" },
      { label: "No definido", value: "No definido", code_sorttime: "CCB000" }, // Dejar este objeto siempre de último
    ];

    var bloodTypeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "A-", value: "A-", code_sorttime: "TSG003" },
      { label: "A+", value: "A+", code_sorttime: "TSG002" },
      { label: "AB-", value: "AB-", code_sorttime: "TSG007" },
      { label: "AB+", value: "AB+", code_sorttime: "TSG005" },
      { label: "B-", value: "B-", code_sorttime: "TSG006" },
      { label: "B+", value: "B+", code_sorttime: "TSG004" },
      { label: "O-", value: "O-", code_sorttime: "TSG008" },
      { label: "O+", value: "O+", code_sorttime: "TSG001" },
      { label: "No definido", value: "No definido", code_sorttime: "TSG000" },
    ];

    var weightOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      {
        label: "De 40 a 45 Kg",
        value: "De 40 a 45 Kg",
        code_sorttime: "PES001",
      },
      {
        label: "De 46 a 50 Kg",
        value: "De 46 a 50 Kg",
        code_sorttime: "PES002",
      },
      {
        label: "De 51 a 55 Kg",
        value: "De 51 a 55 Kg",
        code_sorttime: "PES003",
      },
      {
        label: "De 56 a 60 Kg",
        value: "De 56 a 60 Kg",
        code_sorttime: "PES004",
      },
      {
        label: "De 61 a 65 Kg",
        value: "De 61 a 65 Kg",
        code_sorttime: "PES005",
      },
      {
        label: "De 66 a 70 Kg",
        value: "De 66 a 70 Kg",
        code_sorttime: "PES006",
      },
      {
        label: "De 71 a 75 Kg",
        value: "De 71 a 75 Kg",
        code_sorttime: "PES007",
      },
      {
        label: "De 76 a 80 Kg",
        value: "De 76 a 80 Kg",
        code_sorttime: "PES008",
      },
      {
        label: "De 81 a 85 Kg",
        value: "De 81 a 85 Kg",
        code_sorttime: "PES009",
      },
      {
        label: "De 86 a 90 Kg",
        value: "De 86 a 90 Kg",
        code_sorttime: "PES010",
      },
      {
        label: "De 91 a 95 Kg",
        value: "De 91 a 95 Kg",
        code_sorttime: "PES011",
      },
      { label: "No aplica", value: "No aplica", code_sorttime: "PES012" }, // Dejar este objeto siempre de último
    ];

    var shoeSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Talla 34", value: "Talla 34", code_sorttime: "ZAP011" },
      { label: "Talla 35", value: "Talla 35", code_sorttime: "ZAP001" },
      { label: "Talla 36", value: "Talla 36", code_sorttime: "ZAP002" },
      { label: "Talla 37", value: "Talla 37", code_sorttime: "ZAP003" },
      { label: "Talla 38", value: "Talla 38", code_sorttime: "ZAP004" },
      { label: "Talla 39", value: "Talla 39", code_sorttime: "ZAP005" },
      { label: "Talla 40", value: "Talla 40", code_sorttime: "ZAP006" },
      { label: "Talla 41", value: "Talla 41", code_sorttime: "ZAP007" },
      { label: "Talla 42", value: "Talla 42", code_sorttime: "ZAP008" },
      { label: "Talla 44", value: "Talla 43", code_sorttime: "ZAP009" },
      { label: "Talla 44", value: "Talla 44", code_sorttime: "ZAP010" },
      { label: "No definido", value: "No definido", code_sorttime: "ZAP000" }, // Dejar este objeto siempre de último
    ];

    var pantSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Talla 6", value: "Talla 6", code_sorttime: "PAN013" },
      { label: "Talla 8", value: "Talla 8", code_sorttime: "PAN006" },
      { label: "Talla 10", value: "Talla 10", code_sorttime: "PAN007" },
      { label: "Talla 12", value: "Talla 12", code_sorttime: "PAN008" },
      { label: "Talla 14", value: "Talla 14", code_sorttime: "PAN009" },
      { label: "Talla 16", value: "Talla 16", code_sorttime: "PAN010" },
      { label: "Talla 18", value: "Talla 18", code_sorttime: "PAN014" },
      { label: "Talla 20", value: "Talla 20", code_sorttime: "PAN015" },
      { label: "Talla 28", value: "Talla 28", code_sorttime: "PAN001" },
      { label: "Talla 30", value: "Talla 30", code_sorttime: "PAN002" },
      { label: "Talla 32", value: "Talla 32", code_sorttime: "PAN003" },
      { label: "Talla 34", value: "Talla 34", code_sorttime: "PAN004" },
      { label: "Talla 36", value: "Talla 36", code_sorttime: "PAN005" },
      { label: "Talla 38", value: "Talla 38", code_sorttime: "PAN011" },
      { label: "Talla 40", value: "Talla 40", code_sorttime: "PAN012" },
      { label: "No definido", value: "No definido", code_sorttime: "PAN000" }, // Dejar este objeto siempre de último
    ];

    var shirtSizeOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Talla S", value: "Talla S", code_sorttime: "CAM001" },
      { label: "Talla M", value: "Talla M", code_sorttime: "CAM007" },
      { label: "Talla L", value: "Talla L", code_sorttime: "CAM003" },
      { label: "Talla XL", value: "Talla XL", code_sorttime: "CAM004" },
      { label: "No definido", value: "No definido", code_sorttime: "CAM000" }, // Dejar este objeto siempre de último
    ];

    var drivingLicenseOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "Sí", value: "Sí", code_sorttime: "Sí" },
      { label: "No", value: "No", code_sorttime: "No" }, // Dejar este objeto siempre de último
    ];

    var drivingLicenseCatOptions = [
      // {label: 'choose', value: '', code_sorttime: ''},
      { label: "A1", value: "A1", code_sorttime: "A1" },
      { label: "A2", value: "A2", code_sorttime: "A2" },
      { label: "B1", value: "B1", code_sorttime: "B1" },
      { label: "B2", value: "B2", code_sorttime: "B2" },
      { label: "C1", value: "C1", code_sorttime: "C1" },
      { label: "C2", value: "C2", code_sorttime: "C2" },
      { label: "C3", value: "C3", code_sorttime: "C3" },
      { label: "No aplica", value: "No aplica", code_sorttime: "No aplica" }, // Dejar este objeto siempre de último
    ];

    var levelEducationOptions = CandidateEducationLevelOptions;
    var status: Boolean = false,
      process: Boolean = false;
    var param;
    param = {
      idTrabajador: values.identification_number,
      nombre1: values.name_1,
      nombre2: values.name_2,
      apellido1: values.lastname_1,
      apellido2: values.lastname_2,
      fechaNacimiento: this.sorttimeFormatDate(values.date_birth),
      correo: values.email,
      celular: values.mobile,
    };
    if (values.id_type) {
      param["tipoID"] = this.findValueSorttimeArrayOptions(
        values.id_type,
        idTypeOptions
      );
      if (values.residence_city) {
        if (values.profession_id) {
          if (values.gender) {
            param["sexo"] = this.findValueSorttimeArrayOptions(
              values.gender,
              genderOptions
            );
            if (values.civil_status) {
              param["estadoCivil"] = this.findValueSorttimeArrayOptions(
                values.civil_status,
                civilStatusOptions
              );
              if (values.blood_type) {
                status = true;
                param["grupoSanguineo"] = this.findValueSorttimeArrayOptions(
                  values.blood_type,
                  bloodTypeOptions
                );
                param["paisvive"] = values.residence_country_r.code_sorttime;
                param["departamentoVive"] =
                  values.residence_department_r.code_sorttime;
                param["ciudadVive"] = values.residence_city_r.code_sorttime;
                param["profesion"] = values.profession_r.code_sorttime;
              }
            }
          }
        }
      }
    }
    param["fechaExpedicion"] =
      values.expedition_date == null
        ? null
        : this.sorttimeFormatDate(values.expedition_date);
    param["ciudadExpide"] = values.expedition_city_r
      ? values.expedition_city_r.name
      : null;

    param["Barrio"] = values.neighborhood;
    param["direccion"] = values.address;

    param["paisNacido"] =
      values.birth_country == "" || values.birth_country == null
        ? null
        : values.birth_country_r.code_sorttime;
    param["departamentoNacido"] =
      values.birth_department == "" || values.birth_department == null
        ? null
        : values.birth_department_r.code_sorttime;
    param["ciudadNacido"] =
      values.birth_city == "" || values.birth_city == null
        ? null
        : values.birth_city_r.code_sorttime;
    param["estatura"] =
      values.height_id == "" || values.height_id == null
        ? "EST000"
        : values.height.code_sorttime;

    param["etnico"] =
      values.ethnicity == "" || values.ethnicity == null
        ? ethnicityOptions[ethnicityOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(
            values.ethnicity,
            ethnicityOptions
          );
    param["social"] =
      values.ethnicity == "Sí"
        ? this.findValueSorttimeArrayOptions(
            values.community,
            ethnicGroupOptions
          )
        : ethnicGroupOptions[ethnicGroupOptions.length - 1].code_sorttime;
    param["mujerCF"] =
      values.gender == "Femenino"
        ? this.findValueSorttimeArrayOptions(values.female_hh, femaleHHOptions)
        : femaleHHOptions[femaleHHOptions.length - 1].code_sorttime;
    param["telefono"] = values.phone;
    param["telefono2"] = values.phone_2;

    param["estrato"] =
      values.stratum == "" || values.stratum == null
        ? stratumOptions[stratumOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(values.stratum, stratumOptions);
    param["peso"] =
      values.weight == "" || values.weight == null
        ? weightOptions[weightOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(values.weight, weightOptions);
    param["tallazapatos"] =
      values.shoe_size == "" || values.shoe_size == null
        ? shoeSizeOptions[shoeSizeOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(values.shoe_size, shoeSizeOptions);
    param["tallapantalon"] =
      values.pant_size == "" || values.pant_size == null
        ? pantSizeOptions[pantSizeOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(values.pant_size, pantSizeOptions);
    param["tallacamisa"] =
      values.shirt_size == "" || values.shirt_size == null
        ? shirtSizeOptions[shirtSizeOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(
            values.shirt_size,
            shirtSizeOptions
          );
    param["nivelEducativo"] = this.findValueSorttimeArrayOptions(
      values.eduacational_level,
      levelEducationOptions
    );
    param["LicenciaConducir"] =
      values.driving_license == "" || values.driving_license == null
        ? drivingLicenseOptions[drivingLicenseOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(
            values.driving_license,
            drivingLicenseOptions
          );
    param["categoria"] =
      values.driving_license == "Sí"
        ? this.findValueSorttimeArrayOptions(
            values.driving_license_cat,
            drivingLicenseCatOptions
          )
        : drivingLicenseCatOptions[drivingLicenseCatOptions.length - 1]
            .code_sorttime;
    param["tipoIngreso"] =
      values.sisben == "" || values.sisben == null
        ? sisbenOptions[sisbenOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(values.sisben, sisbenOptions);
    param["calificacionCasa"] =
      values.house_type == "" || values.house_type == null
        ? houseTypeOptions[houseTypeOptions.length - 1].code_sorttime
        : this.findValueSorttimeArrayOptions(
            values.house_type,
            houseTypeOptions
          );

    if (status == false) param = null;
    return param;
  }

  public sorttimeFormatDate(date) {
    const d = new Date(date);
    let month = "" + (d.getMonth() + 1);
    let day = "" + d.getDate();
    let year = d.getFullYear();

    if (month.length < 2) month = "0" + month;

    if (day.length < 2) day = "0" + day;

    return [day, month, year].join("/");
  }
  public findValueSorttimeArrayOptions(value: string, nameArray: any[]) {
    var resp;
    nameArray.forEach((element) => {
      if (element.value == value) resp = element.code_sorttime;
    });
    return resp;
  }

  public changeResult(variable: any, formControlName: string) {
    const value = this.form.controls[formControlName].value;
    variable = value;
  }

  public getStatusObject(eventObjetc, nameObject: string) {
    var status = false;
    if (eventObjetc) {
      if (eventObjetc.value == nameObject) status = true;
    }
    //   status = true;

    return status;
  }

  public getStatusRadioButton(formValue, nameValue: any) {
    var status = false;
    if (formValue) {
      if (formValue == nameValue) status = true;
    }

    return status;
  }

  public hideNotifyButton(formValue, nameValue: any) {
    var status = false;
    if (formValue == nameValue) status = true;

    return status;
  }

  public sendValuesPart(citation: any) {
    {
      var param;

      // if (this.needConfirmation == true){
      //   this.modConfirmationDialog=true;
      //   // this.showConfirmationDialog();
      // }
    }
    if (this.minimum && this.editPart == "interview") {
      param = {
        start_interview: citation.start_interview,
        end_interview: citation.end_interview,
        interviewed_by_id: citation.interviewed_by_id,
        result_interview: citation.result_interview,
        emergency_contact: citation.emergency_contact,
        emergency_contact_number: citation.emergency_contact_number,
        observation_interview: citation.observation_interview,
        observation_personal_familiar: citation.observation_personal_familiar,
        academic_information: citation.academic_information,
        work_experience: citation.work_experience,
        observation_final_concept: citation.observation_final_concept,
      };
    } else if (this.minimum && this.editPart == "test") {
      param = {
        start_test: citation.start_test,
        end_test: citation.end_test,
        tested_by_id: citation.tested_by_id,
        result_test: citation.result_test,
        test: citation.test,
        observation_test: citation.observation_test,
      };
    } else if (this.minimum && this.editPart == "send_customer") {
      param = {
        start_send_customer: citation.start_send_customer,
        end_send_customer: citation.end_send_customer,
        send_customer_by_id: citation.send_customer_by_id,
        result_send_customer: citation.result_send_customer,
        // 'state_backup': citation.state_backup,
        // 'observation_backup': citation.observation_backup,
        observation_send_customer: citation.observation_send_customer,
      };
    } else if (this.minimum && this.editPart == "documental_analysis") {
      param = {
        start_documental_analysis: citation.start_documental_analysis,
        end_documental_analysis: citation.end_documental_analysis,
        documental_analysis_by_id: citation.documental_analysis_by_id,
        result_documental_analysis: citation.result_documental_analysis,
        observation_documental_analysis:
          citation.observation_documental_analysis,
      };
    } else if (this.minimum && this.editPart == "referencing") {
      param = {
        start_referencing: citation.start_referencing,
        end_referencing: citation.end_referencing,
        referencing_by_id: citation.referencing_by_id,
        result_referencing: citation.result_referencing,
        observation_referencing: citation.observation_referencing,
      };
    } else if (this.minimum && this.editPart == "background_validation") {
      param = {
        start_background_validation: citation.start_background_validation,
        end_background_validation: citation.end_background_validation,
        background_validation_by_id: citation.background_validation_by_id,
        result_background_validation: citation.result_background_validation,
        observation_background_validation:
          citation.observation_background_validation,
      };
    } else if (this.minimum && this.editPart == "medical_exams") {
      param = {
        start_medical_exams: citation.start_medical_exams,
        end_medical_exams: citation.end_medical_exams,
        date_medical_appointment: citation.date_medical_appointment,
        date_medical_appointment_result:
          citation.date_medical_appointment_result,
        date_medical_appointment_two: citation.date_medical_appointment_two,
        date_medical_appointment_result_two:
          citation.date_medical_appointment_result_two,
        date_medical_appointment_three: citation.date_medical_appointment_three,
        date_medical_appointment_result_three:
          citation.date_medical_appointment_result_three,
        medical_exams_by_id: citation.medical_exams_by_id,
        result_medical_exams: citation.result_medical_exams,
        lab_medical_exams: citation.lab_medical_exams,
        come_medical_exams: citation.come_medical_exams,
        cost_center: citation.cost_center,
        observation_medical_exams: citation.observation_medical_exams,
      };
    } else if (this.minimum && this.editPart == "hire") {
      param = {
        hiring_analyst_id: citation.hiring_analyst_id,
        manager_send_hiring_sign_by_id: citation.manager_send_hiring_sign_by_id,
        start_hire: citation.start_hire,
        end_hire: citation.end_hire,
        hire_by_id: citation.hire_by_id,
        result_hire: citation.result_hire,
        observation_hire: citation.observation_hire,
      };
    } else if (this.minimum && this.editPart == "income_order") {
      param = {
        suggested_date_medical_exam: citation.suggested_date_medical_exam,
        admission_date: citation.admission_date,
        retirement_date: citation.retirement_date,
        cost_center: citation.cost_center,
        person_arl: citation.person_arl,
        person_labor: citation.person_labor,
        workplace: citation.workplace,
        working_day: citation.working_day,
        working_day_other:
          citation.working_day == "Especial"
            ? citation.working_day_other
            : null,
        modality: citation.modality,
        salary: citation.salary,
        salary_type: citation.salary_type,
        salary_modality: citation.salary_modality,
        payment_type: citation.payment_type,
        commissions: citation.commissions,
        extralegal_benefits: citation.extralegal_benefits,
        person_additional_requirements: citation.person_additional_requirements,
        employee_city_id: citation.employee_city_id,
        filing_date:
          this.edit.filing_date != null &&
          this.edit.filing_date != "" &&
          this.edit.filing_date != undefined
            ? this.edit.filing_date
            : formatDate(new Date()),
        start_send_income_order: citation.start_send_income_order,
        send_income_order: citation.send_income_order,
        customer_approved_id: citation.customer_approved_id,
        authorization_observations:
          citation.customer_approved_id == "4"
            ? citation.authorization_observations
            : null,
      };
    } else {
      param = citation;
    }

    return param;
  }
  // public getRoleId(){
  //     var employeePosition = JSON.parse(localStorage.getItem('profile')).employee.employee_position_id;
  //     return (employeePosition);
  // }
  public getRoleId() {
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    return role;
  }
  public enableOptionsHire(employeePosition) {
    var resp = true;
    var array = this.rolesPermissionChangeHire.split(",");
    // array.push(...this.employeePositionToAdmin.split(','));
    const elementosEncontrados = array.filter(
      (item) => item == employeePosition
    );
    if (elementosEncontrados.length > 0) resp = false;
    return resp;
  }

  public notifySendIncomeOrder() {
    this.modViewNotifyCustomer = true;
  }

  public saveNotifyCustomer(values) {
    let citation_id = parseInt(this.idCitation);

    // values.requisition_id = this.idRequisition;

    if (values) {
      const promise = this.citationService.incomeOrderCustomerNotification(
        citation_id,
        values
      );
      this.promiseForm = promise.toPromise().then(
        (response) => {
          const result = response.json();
          this.notifyCustomerResult(result);
          this.modViewNotifyCustomer = false;
          // this.close.emit(true);
          // this.form.reset();
        },
        (error) => {
          this.msgs.push({ severity: "error", summary: "Error" });
        }
      );
    }
  }

  private notifyCustomerResult(result: any) {
    const emailSent = !!result.email_sent;
    const whatsappSent = !!result.whatsapp_sent;
    const whatsappAttempted = !!result.whatsapp_attempted;

    if (emailSent && (whatsappSent || !whatsappAttempted)) {
      this.notificationsService.growlNotify(
        "success",
        "Notificación enviada",
        whatsappAttempted
          ? "Correo enviado y WhatsApp enviado."
          : "Correo enviado."
      );
    } else if (emailSent && whatsappAttempted && !whatsappSent) {
      this.notificationsService.growlNotify(
        "warn",
        "Notificación parcial",
        "Correo enviado. WhatsApp no enviado."
      );
    } else if (!emailSent && whatsappSent) {
      this.notificationsService.growlNotify(
        "warn",
        "Notificación parcial",
        "Correo no enviado. WhatsApp enviado."
      );
    } else {
      this.notificationsService.growlNotify(
        "error",
        "Notificación no enviada",
        "Correo no enviado. WhatsApp no enviado."
      );
    }
  }

  public cancelNotifyCustomer() {
    this.modViewNotifyCustomer = false;
  }

  public changeStatusCustomerApprovedID(customerApprovedId) {
    if (this.currentRoleId == 59) {
      if (customerApprovedId == "4") customerApprovedId = "2";
      else if (customerApprovedId == "3") customerApprovedId = "1";
    } else {
      if (customerApprovedId == "2") customerApprovedId = "4";
      else if (customerApprovedId == "1") customerApprovedId = "3";
    }

    return customerApprovedId;
  }

  public sendResponseCustomerApprovedID(
    customerApprovedIdPrevious,
    customerApprovedIdForm
  ) {
    if (customerApprovedIdPrevious == "2" && customerApprovedIdForm == "4")
      return customerApprovedIdPrevious;
    if (customerApprovedIdPrevious == "1" && customerApprovedIdForm == "3")
      return customerApprovedIdPrevious;
    return customerApprovedIdForm;
  }

  public getDisableFieldsAdmissionDate(customer_approved_id) {
    var options_customer_approved_id = [1, 2, 3, 4];
    if (options_customer_approved_id.indexOf(customer_approved_id) != -1) {
      if (!this.hasPermission("reissue income order")) {
        this.form.controls["customer_approved_id"].disable();

        this.form.controls["suggested_date_medical_exam"].disable();
        this.form.controls["admission_date"].disable();
        this.form.controls["retirement_date"].disable();
        this.form.controls["cost_center"].disable();
        this.form.controls["person_arl"].disable();
        this.form.controls["person_labor"].disable();
        this.form.controls["workplace"].disable();
        this.form.controls["working_day"].disable();
        this.form.controls["working_day_other"].disable();
        this.form.controls["modality"].disable();
        this.form.controls["salary"].disable();
        this.form.controls["salary_type"].disable();
        this.form.controls["salary_modality"].disable();
        this.form.controls["payment_type"].disable();
        this.form.controls["commissions"].disable();
        this.form.controls["extralegal_benefits"].disable();
        this.form.controls["person_additional_requirements"].disable();
        // this.form.get('employee_city_id').disable();
        this.employeeCityIdDisable = true;
      }
    } else {
      if (this.hasPermission("get user company")) {
        this.form.controls["suggested_date_medical_exam"].disable();
        // this.form.controls['admission_date'].disable();
        // this.form.controls['retirement_date'].disable();
        this.form.controls["cost_center"].disable();
        this.form.controls["person_arl"].disable();
        this.form.controls["person_labor"].disable();
        this.form.controls["workplace"].disable();
        // this.form.controls['working_day'].disable();
        // this.form.controls['working_day_other'].disable();
        this.form.controls["modality"].disable();
        // this.form.controls['salary'].disable();
        this.form.controls["salary_type"].disable();
        this.form.controls["salary_modality"].disable();
        this.form.controls["payment_type"].disable();
        this.form.controls["commissions"].disable();
        this.form.controls["extralegal_benefits"].disable();
        this.form.controls["person_additional_requirements"].disable();
        // this.form.controls['employee_city_id'].disable();
        this.employeeCityIdDisable = true;
      }
    }
  }

  public getRequiredAuthorization(value: any) {
    if (value == "4")
      this.form
        .get("authorization_observations")
        .setValidators([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(500),
        ]);
    else this.form.get("authorization_observations").setValidators([]);

    this.form.get("authorization_observations").updateValueAndValidity();
  }

  printCitationIncomeOrder(citation_id) {
    window.open(
      this.apiUrl +
        "/citations-income-order/" +
        citation_id +
        "/pdf?token=" +
        localStorage.getItem("token"),
      "_blank"
    );
  }

  getEnableAuthorization(admission_date) {
    const limitHours = 7;
    let status = true;
    let admission_date_zero_hours = new Date(admission_date);
    admission_date_zero_hours.setHours(0, 0, 0, 0);

    let today = new Date();

    let diff = admission_date_zero_hours.getTime() - today.getTime(); // Direfencia en milisegundos
    diff = Math.ceil(diff / (1000 * 3600)); // Convirtiendo a horas

    if (diff >= 0) {
      if (diff <= limitHours) status = false;
    } else status = false;

    // console.log('La diferencia de fechas es: ' + diff);
    return status;
  }
  public sendInformationtoBotzy(citation_sel: Attendance) {
    let data: any = {};
    data.id = citation_sel.id;
    data.candidate = citation_sel.candidate
      ? citation_sel.candidate
      : this.show_candidate_info;
    data.company_name = citation_sel.requisition
      ? citation_sel.requisition.company.name
      : this.show_company;
    data.profile_survey = citation_sel.requisition
      ? citation_sel.requisition.profile_survey_small
      : this.show_profile_survey_small;
    this.citationService
      .botzyManagementDocumental(data)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          this.translate.get("error").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "error", summary: res });
          });
        }
      );
  }

  public sendInfoCandidateRejectedBotzy(citation_sel: Attendance) {
    let data: any = {};
    data.id = citation_sel.id;
    data.candidate = citation_sel.candidate
      ? citation_sel.candidate
      : this.show_candidate_info;
    data.profile_survey = citation_sel.requisition
      ? citation_sel.requisition.profile_survey_small
      : this.show_profile_survey_small;
    this.citationService
      .botzyRejectedCandidate(data)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          this.translate.get("error").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "error", summary: res });
          });
        }
      );
  }

  public sendHireInformationtoBotzy(citation_sel: Attendance) {
    let data: any = {};
    data.id = citation_sel.id;
    data.candidate = citation_sel.candidate
      ? citation_sel.candidate
      : this.show_candidate_info;
    data.admission_date = citation_sel.admission_date;
    data.first_day_instruction = citation_sel.first_day_instruction;

    this.citationService
      .botzyHire(data)
      .toPromise()
      .then(
        (response) => {
          this.translate.get("saved").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "success", summary: res });
          });
        },
        (error) => {
          this.translate.get("error").subscribe((res: string) => {
            this.msgs = [];
            this.msgs.push({ severity: "error", summary: res });
          });
        }
      );
  }

  public restartSendIncomeOrder() {
    let citation_id = parseInt(this.idCitation);

    const promise =
      this.citationService.restartSendIncomeOrderCitation(citation_id);
    this.promiseForm = promise.toPromise().then(
      (response) => {
        this.translate
          .get("ready, you can regenerate the admission order")
          .subscribe((res: string) => {
            this.notificationsService.growlNotify("success", res);
            let cit = response.json();

            this.form.get("result_hire").setValue(cit.result_hire);
            this.form.get("start_hire").setValue(cit.start_hire);
            this.form.get("end_hire").setValue(cit.end_hire);
            this.form.get("hire_by_id").setValue(cit.hire_by_id);
            this.form
              .get("customer_approved_id")
              .setValue(cit.customer_approved);
            this.form.get("send_hiring").setValue(cit.send_hiring);
            this.form.get("start_send_hiring").setValue(cit.start_send_hiring);
          });
      },
      (error) => {
        this.msgs.push({ severity: "error", summary: "Error" });
      }
    );
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/citations/new-citation/new-citation.component.ts